import React from 'react';
import {useStakingContract} from "../../context/StakingContract";
import StakingContract from "../../context/StakingContract/StakingContract";


const TopInfo = () => {
  const {state} = useStakingContract();
  const {prerequisites, staking, allowance} = state;
  return (
    <div className="card mb-4">
      <div className="card-body">
        <div className="item row">
          <div className="key col-md-3">Your address</div>
          <div className="value col-md-9">{prerequisites.connectedAddress}</div>
        </div>
        <div className="item row">
          <div className="key col-md-3">Contract address</div>
          <div className="value col-md-9">{StakingContract.getEnv("REACT_APP_ETH_DEPLOYED_CONTRACT")}</div>
        </div>
        {
          allowance.existing > 0 && (
            <div className="item row">
              <div className="key col-md-3">Allowance</div>
              <div className="value col-md-9">{allowance.existing.toLocaleString('en')} ERD</div>
            </div>
          )
        }
        {(staking.stakingValue > 0 && staking.showStake) && (
          <div className="item row">
            <div className="key col-md-3">Staking amount</div>
            <div className="value col-md-9">{staking.stakingValue.toLocaleString('en')} ERD</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TopInfo;